// extracted by mini-css-extract-plugin
module.exports = {"header":"BuyLinks_header__2B-gT","button":"BuyLinks_button__sGlVx","active":"BuyLinks_active__36r6_","name":"BuyLinks_name__cLp61","load":"BuyLinks_load__1NdIt"};